import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import styles from "./offerCard.module.css";
import { toast } from "react-toastify";
import { reactToast } from "../../helper";

import {
  SESSION_TYPE,
  MONTHLY_TYPE,
  DEMO_TYPE,
  STATUS_AVAILABLE,
  TEACHING_MODE,
  TEACHER_ROLE,
  RETAKE_TYPE,
} from "../../constants";
import { MdCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeacherSlots } from "../../services/teacher";
import { fetchTeacherCourseData } from "../../redux/slice/teacherCourseData/teacherCourseDataThunk";
import TeacherSlots from "../teacher-slots";
import { createOfferRequest } from "../../services/offers";
import Loader from "../loader";
import { MdOutlineCancel } from "react-icons/md";
import Dropdown from "../Dropdown";
import { fetchAllSubjects } from "../../services/subjects";

const CreateOfferCard = ({
  open,
  handleOk,
  handleCancel,
  onSendOffer,
  studentId,
  teacherId,
  offerDetail,
  setOfferDetail,
  ...rest
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [price, setPrice] = useState("");
  const [course, setCourse] = useState("");
  const [offerRequestLoading, setOfferRequestLoading] = useState(false);
  const dispatch = useDispatch();
  const teacherCourses = useSelector((state) => state.teacherCourseData);
  const loggedInUser = useSelector((state) => state.auth.user);

  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newTemporarySubject, setNewTemporarySubject] = useState("");
  const [temporarySubjectsList, setTemporarySubjectsList] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [teachingMode, setTeachingMode] = useState(TEACHING_MODE.ONLINE);

  useEffect(() => {
    if (open) {
      getAllSubjects();
      handleResetState();
      // price will be zero if user needs a demo.
      if (offerDetail?.offerType === DEMO_TYPE || offerDetail?.offerType === RETAKE_TYPE) {
        setPrice("0");
      }
    }
    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleResetState = () => {
    setSelectedSlots([]);
    setSelectedSubjects([]);
    setTemporarySubjectsList([]);
    setSlots([]);
    setNewTemporarySubject("");
    setStartDate("");
    setEndDate("");
    setPrice("");
    setCourse("");
    setTeachingMode(TEACHING_MODE.ONLINE);
  };

  const handleSearchSlots = () => {
    if (teacherId && startDate && endDate) {
      getTeacherSlots(teacherId, startDate, endDate);
    }
  };

  const getTeacherSlots = async (teacherId, startDate, endDate) => {
    try {
      setSlots([]);
      setSelectedSlots([]);
      setLoading(true);
      // when teacher will fetch slots then it will be logged in user
      let requestId =
        loggedInUser?.role === TEACHER_ROLE ? loggedInUser?.id : teacherId;
      const { status, data } = await fetchTeacherSlots(requestId, {
        startDate: startDate,
        endDate: endDate,
        teacherId: requestId,
      });
      if (status === 201) {
        if (data?.data?.length) {
          setSlots(data?.data);
        }
      } else {
        reactToast("error", data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getAllSubjects = async () => {
    try {
      const { status, data } = await fetchAllSubjects();
      if (status === 200) {
        if (data?.data?.length) {
          setAllSubjects(data?.data);
        }
      } else {
        reactToast("error", data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teacherId && open) {
      dispatch(fetchTeacherCourseData(teacherId));
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherId, open]);

  const handleCloseModal = () => {
    handleCancel();
  };

  const handleSlots = (e, slot) => {
    let checked = e.target.checked;
    if (
      offerDetail?.offerType !== MONTHLY_TYPE &&
      checked &&
      selectedSlots?.length
    ) {
      reactToast(
        "error",
        `You can not select more than one slot in ${offerDetail?.offerType}`
      );
      return;
    }
    if (checked) {
      let prevSelectedSlots = [...selectedSlots];
      prevSelectedSlots.push(slot);
      setSelectedSlots(prevSelectedSlots);
    } else {
      let prevSelectedSlots = [...selectedSlots];
      let filter = prevSelectedSlots?.filter(
        (item) => item?.uuid !== slot?.uuid
      );
      setSelectedSlots(filter);
    }
  };

  const getObjectsNotInArray = (arr1, arr2) => {
    const arr2Ids = new Set(arr2.map((obj) => obj?.uuid)); // Assuming objects have an 'id' property

    return arr1.filter((obj) => !arr2Ids.has(obj?.uuid));
  };
  const matchedAllSlotsLength = (currectSLot) => {
    let sameDaySlots = filterSameDaySlots(currectSLot, slots);
    let filtered = selectedSlots?.filter(
      (item) =>
        item?.dayName === currectSLot?.dayName &&
        item?.dayNameId === currectSLot?.dayNameId &&
        item?.startTime === currectSLot?.startTime &&
        item?.endTime === currectSLot?.endTime
    );
    return sameDaySlots?.length === filtered?.length;
  };
  const filterSameDaySlots = (selected, allSlots) => {
    let slots = [];

    for (let index = 0; index < allSlots.length; index++) {
      const week = allSlots[index];
      for (const [key, value] of Object.entries(week)) {
        if (value?.length) {
          for (let weekIndex = 0; weekIndex < value.length; weekIndex++) {
            const weekElement = value[weekIndex];
            if (
              weekElement?.dayNameId === selected?.dayNameId &&
              weekElement?.endTime === selected?.endTime &&
              weekElement?.startTime === selected?.startTime &&
              weekElement?.status === STATUS_AVAILABLE
            ) {
              slots.push(weekElement);
            }
          }
        }
      }
    }
    // let filterSlots = getObjectsNotInArray(slots, selectedSlots);
    // return filterSlots;
    return slots;
  };

  const handleBookAllSlotsForSameDay = (e, slot) => {
    let checked = e.target.checked;
    if (checked) {
      let prevSelectedSlots = [...selectedSlots];
      let filtered = filterSameDaySlots(slot, slots);
      let result = getObjectsNotInArray(filtered, selectedSlots);
      prevSelectedSlots.push(...result);
      setSelectedSlots(prevSelectedSlots);
    } else {
      let prevSelectedSlots = [...selectedSlots];
      let filtered = prevSelectedSlots?.filter(
        (item) =>
          item?.dayName !== slot?.dayName &&
          item?.dayNameId !== slot?.dayNameId &&
          item?.startTime !== slot?.startTime &&
          item?.endTime !== slot?.endTime
      );
      setSelectedSlots(filtered);
    }
  };
  const validateOffer = (offer) => {
    // demo offer will always zero price
    if (offerDetail?.offerType === DEMO_TYPE || offerDetail?.offerType === RETAKE_TYPE) {
      offer.price = "0";
    }
    if (
      offerDetail?.offerType !== DEMO_TYPE && offerDetail?.offerType !== RETAKE_TYPE &&
      !selectedSubjects?.length &&
      !temporarySubjectsList?.length
    ) {
      reactToast("error", "Please add atleast one subject.");
      return false;
    }

    if (
      !offer?.slots.length ||
      !offer?.offerType ||
      !offer?.startDate ||
      !offer?.endDate ||
      !offer?.price
    ) {
      return false;
    }

    // check if subject is selected then
    // Check if each subject has required fields
    if (selectedSubjects?.length) {
      for (const subject of offer.subjects) {
        const requiredSubjectFields = [
          "subjectId",
          "subjectName",
          "levelId",
          "levelName",
        ];
        for (const field of requiredSubjectFields) {
          if (!subject.hasOwnProperty(field) || !field) {
            return false; // Missing required field in subject
          }
        }
      }
    }

    return true; // All validations passed
  };

  const getLevelsBySubjectId = (subjectId) => {
    const subject = teacherCourses?.data?.find(
      (subject) => subject.subjectId === parseInt(subjectId)
    );
    return subject ? subject?.courseOfferingLevels : [];
  };

  const handleSelection = (type) => {
    handleResetState();
    setOfferDetail((prev) => ({
      ...prev,
      offerType: type,
    }));
  };

  const haddleSendOffer = async () => {
    try {
      let payload = {
        ...offerDetail,
        price,
        startDate,
        endDate,
        slots: selectedSlots,
        subjects: selectedSubjects,
        extraSubjects: temporarySubjectsList,
        teachingMode,
      };
      let validate = validateOffer(payload);
      if (!validate) {
        toast.error("Please select all fields!");
        return;
      }
      setOfferRequestLoading(true);

      setOfferDetail((prev) => ({
        ...prev,
        ...payload,
      }));
      const { status, data } = await createOfferRequest({
        ...payload,
        teacherId,
        studentId,
      });
      if (status === 201) {
        reactToast("success", data?.message);
        await onSendOffer({ ...payload, offerId: data?.data?.offerId });
      } else {
        reactToast("error", data?.message);
      }
      setOfferRequestLoading(false);
    } catch (error) {
      setOfferRequestLoading(false);
    }
  };

  const handleSubjectChange = (e) => {
    const subjectId = e.target.value;
    setCourse(subjectId);
    let matchedSubject = teacherCourses?.data?.find(
      (item) => item?.subjectId === parseInt(subjectId)
    );
    let alradyExits = selectedSubjects?.find(
      (item) => parseInt(item?.subjectId) === parseInt(subjectId)
    );
    if (alradyExits) {
      toast.error(`${alradyExits?.subjectName} already exits!`);
      return;
    }
    const newSubject = {
      subjectId,
      subjectName: matchedSubject?.subjectName,
      levelId: "",
      levelName: "",
    };
    setSelectedSubjects([...selectedSubjects, newSubject]);
  };

  const handleMoreSubjecs = (e) => {
    const subjectId = e.target.value;
    setNewTemporarySubject(subjectId);
    let matchedSubject = allSubjects?.find(
      (item) => item?.id === parseInt(subjectId)
    );
    let alradyExits = temporarySubjectsList?.find(
      (item) => parseInt(item?.subjectId) === parseInt(subjectId)
    );
    if (alradyExits) {
      toast.error(`${alradyExits?.subjectName} already exits!`);
      return;
    }
    const newSubject = {
      subjectId,
      subjectName: matchedSubject?.name,
    };
    setTemporarySubjectsList([...temporarySubjectsList, newSubject]);
  };

  const handleSubjectLevel = (subject, e) => {
    let value = e.target.value;
    const levelName = findLevelName(subject, value);

    const updatedSubjects = selectedSubjects.map((item) =>
      item.subjectId === subject.subjectId
        ? { ...item, levelName, levelId: value }
        : item
    );
    setSelectedSubjects(updatedSubjects);
  };

  const findLevelName = (subject, levelId) => {
    const matchedSubject = teacherCourses?.data?.find(
      (ele) => ele.subjectId === parseInt(subject?.subjectId)
    );
    const matchedLevel = matchedSubject?.courseOfferingLevels?.find(
      (level) => level.id === parseInt(levelId)
    );
    return matchedLevel ? matchedLevel.name : "";
  };

  const removeSelectedSubject = (subject) => {
    setCourse("");
    const updatedSubjects = selectedSubjects.filter(
      (item) => item.subjectId !== subject.subjectId
    );
    setSelectedSubjects(updatedSubjects);
  };

  const handleStartDate = (e) => {
    setSlots([]);
    setSelectedSlots([]);
    setEndDate("");
    setStartDate(e.target.value);
    if (
      offerDetail?.offerType === SESSION_TYPE ||
      offerDetail?.offerType === DEMO_TYPE 
      || offerDetail?.offerType === RETAKE_TYPE
    ) {
      setEndDate(e.target.value);
    }
  };

  const handleDeleteTemporartSubject = (subjectId) => {
    const updatedList = [...temporarySubjectsList];
    let filter = updatedList?.filter(
      (item) => Number(item?.subjectId) !== Number(subjectId)
    );
    setTemporarySubjectsList(filter);
  };
  const handleTeachingMode = (e) => {
    let value = e.target.value;
    handleResetState();
    setTeachingMode(value);
  };
  return (
    <Modal
      maskClosable={false}
      footer={null}
      closable
      title=""
      open={open}
      onOk={handleOk}
      onCancel={handleCloseModal}
      width={800}
      // style={{
      //   top: 20,
      // }}
      className="modalBg"
      {...rest}
    >
      <div className={styles["modal-body"]}>
        {/* Button Code */}
        <div className="row">
          <div className="col-md-3">
            <span>Teaching Mode:</span>
            <div className="form-check">
              <input
                checked={teachingMode === TEACHING_MODE.ONLINE}
                name={"teachingMode"}
                value={TEACHING_MODE.ONLINE}
                onChange={handleTeachingMode}
                className="form-check-input"
                type="radio"
              />
              <label
                className="form-check-label fs_12 text-capitalize"
                htmlFor="cityCheckbox1"
              >
                {TEACHING_MODE.ONLINE}
              </label>
            </div>
            <div className="form-check">
              <input
                checked={teachingMode === TEACHING_MODE.HOME}
                name={"teachingMode"}
                value={TEACHING_MODE.HOME}
                onChange={handleTeachingMode}
                className="form-check-input"
                type="radio"
              />
              <label
                className="form-check-label fs_12 text-capitalize"
                htmlFor="cityCheckbox1"
              >
                {TEACHING_MODE.HOME}
              </label>
            </div>
          </div>
          {(offerDetail?.offerType !== DEMO_TYPE && offerDetail?.offerType !== RETAKE_TYPE) ? (
            <div className={`col-md-6 text-center d-md-block  py-2 `}>
              {teachingMode !== TEACHING_MODE.HOME ? (
                <button
                  onClick={() => handleSelection(SESSION_TYPE)}
                  className={`btn mb-3 mx-2 shadow-sm px-5 primary_border_color ${
                    offerDetail?.offerType === SESSION_TYPE
                      ? "btn-primary primary_bg_color"
                      : ""
                  }`}
                  type="button"
                >
                  Session
                </button>
              ) : (
                ""
              )}
              <button
                onClick={() => handleSelection(MONTHLY_TYPE)}
                className={`btn mb-3 mx-2 shadow-sm px-5 primary_border_color ${
                  offerDetail?.offerType === MONTHLY_TYPE
                    ? "btn-primary primary_bg_color"
                    : ""
                } shadow-sm mb-3 `}
                type="button"
              >
                Monthly
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        {/* DatePicker */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center flex-wrap">
              {(offerDetail?.offerType === SESSION_TYPE ||
                offerDetail?.offerType === DEMO_TYPE || offerDetail?.offerType === RETAKE_TYPE) && (
                <div className="mt-1">
                  Date
                  <input
                    className="ms-2 p-1"
                    onChange={handleStartDate}
                    value={startDate || ""}
                    type="date"
                    name="date"
                    min={today}
                  />
                </div>
              )}
              {offerDetail?.offerType === MONTHLY_TYPE && (
                <div className="d-flex justify-content-between mt-1">
                  <div>
                    From:
                    <input
                      min={today}
                      className="ms-2 p-1 me-3"
                      onChange={handleStartDate}
                      value={startDate || ""}
                      type="date"
                      name="startDate"
                    />
                  </div>
                  <div>
                    To:
                    <input
                      disabled={!startDate}
                      min={startDate}
                      className="ms-2 p-1"
                      onChange={(e) => setEndDate(e.target.value)}
                      value={endDate || ""}
                      type="date"
                      name="endDate"
                    />
                  </div>
                </div>
              )}
              <button
                disabled={loading}
                onClick={handleSearchSlots}
                type="button"
                className="btn btn_contained text-white btn-sm mt-1 ms-3"
              >
                {" Search Slots"}
              </button>
            </div>
          </div>
        </div>

        <div>
          <TeacherSlots
            onCheckAllSameDaySlots={matchedAllSlotsLength}
            offerDetail={offerDetail}
            loading={loading}
            slots={slots}
            onSelect={handleSlots}
            selectedSlots={selectedSlots}
            onSelectSameSlots={handleBookAllSlotsForSameDay}
          />
        </div>

        {/* Slots */}

        {(offerDetail?.offerType !== DEMO_TYPE && offerDetail?.offerType !== RETAKE_TYPE) && (
          <>
            <div className="row mb-3">
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <label htmlFor="subjectSelect" className="form-label">
                  Select Subject
                </label>
                <select
                  id="subjectSelect"
                  className="form-select"
                  value={course || ""}
                  aria-label="Default select example"
                  onChange={handleSubjectChange}
                >
                  <option value="">Select a subject</option>
                  {teacherCourses?.data?.map((subject) => (
                    <option key={subject.subjectId} value={subject.subjectId}>
                      {subject.subjectName}
                    </option>
                  ))}
                </select>
                <div className="selected-subjects mt-2 d-flex row mx-1">
                  {selectedSubjects.map((subject, index) => (
                    <div
                      style={{ width: "100px" }}
                      key={index}
                      className="selected-subject d-flex flex-column primary_bg_color align-items-start p-2 text-white col-4 my-1 me-1 fs_12"
                    >
                      <div className="d-flex justify-content-between w-100">
                        <span>{subject.subjectName}</span>
                        <MdCancel
                          size={10}
                          style={{
                            marginTop: "5px",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => removeSelectedSubject(subject)}
                        />
                      </div>
                      {/* Dropdown */}
                      <select
                        // value={subject?.levelName}
                        className="form-select mt-1 fs_12 p-1"
                        onChange={(e) => handleSubjectLevel(subject, e)}
                      >
                        <option value="">Level</option>
                        {getLevelsBySubjectId(subject?.subjectId).map(
                          (level, idx) => (
                            <option key={level.id} value={level.id}>
                              {level.name}
                            </option>
                          )
                        )}
                      </select>
                      {/* Dropdown */}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <label htmlFor="subjectSelect" className="form-label">
                  Add More Subjects
                </label>
                <Dropdown
                  name="otherSubjects"
                  selected={newTemporarySubject}
                  onChange={handleMoreSubjecs}
                  options={allSubjects}
                />

                <div className="d-flex flex-wrap">
                  {temporarySubjectsList.map((subject, index) => (
                    <span
                      key={index}
                      onClick={() =>
                        handleDeleteTemporartSubject(subject?.subjectId)
                      }
                      className="badge badge-secondary primary_bg_color m-2"
                    >
                      {subject?.subjectName} <MdOutlineCancel size={20} />
                    </span>
                  ))}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <label htmlFor="exampleInputEmail1" className="mb-2">
                  Your Offer Price *
                </label>
                <input
                  min="1"
                  value={price || ""}
                  onChange={(e) => setPrice(e.target.value)}
                  type="number"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="Your Offer Price"
                  placeholder="0"
                />
              </div>
            </div>
          </>
        )}
      </div>

      {/* Buttons Cancel and Send */}
      <div className="d-flex justify-content-end pe-3">
        <button
          disabled={offerRequestLoading}
          onClick={handleCloseModal}
          type="button"
          className="btn btn_outlined btn-sm me-2"
        >
          Cancel
        </button>
        <button
          disabled={offerRequestLoading}
          onClick={haddleSendOffer}
          type="button"
          className="btn btn_contained text-white btn-sm "
        >
          {offerRequestLoading ? <Loader /> : " Send Offer"}
        </button>
      </div>
      {/* Buttons Cancel and Send */}
    </Modal>
  );
};

export default CreateOfferCard;
